<!--
    课程分享-课时编辑-课时组件
    作用：子组件详情
    功能：展示子组件信息，实现拖动编辑数据
    说明：版本3.0
-->
<template>
  <div class="wrapper">
    <draggable
      :value="list"
      class="draggable-wrap"
      @end.stop="handlerDraggable">
      <class-item
        v-for="(item,index) in list"
        :key="index"
        :info="item"
        :is-close="isClose"
        @remove="handlerRemove(item)"
        @edit="handlerEdit(item)"
        @move="handlerMove(item)"
        @change="handlerChange"/>
      <div
        class="add-class"
        @click="gotoAdd"><i class="el-icon-plus"/></div>
    </draggable>
  </div>
</template>
<script>
import { updatePacketHours } from '@/api/courseOn';
import classItem from './classItem.vue';
import draggable from 'vuedraggable';

export default {
  name: 'ClassHourse',
  components: {
    classItem,
    draggable,
  },
  props: {
    list: Array,
  },
  data() {
    return {
      resultId: [],
      isClose: false,
    };
  },
  mounted() {
    this.list.forEach((item) => {
      this.resultId.push(item.result_id);
    });
  },
  methods: {
    handlerDraggable({ newIndex, oldIndex }) {
      if (oldIndex < this.list.length) {
        const list = [].concat(this.list);
        const allData = JSON.parse(sessionStorage.getItem('classHours'));
        const oldItem = list[oldIndex];// 移动项
        const newItem = list[newIndex]; // 被插入项
        let toIndex;// 去的位置
        allData.forEach((item, index) => {
          if (item.result_id === newItem.result_id) {
            toIndex = index;
          }
        });
        const firstArr = [];
        const endArr = [];
        allData.forEach((item, index) => {
          if (item.result_id !== oldItem.result_id) {
            if (index > toIndex) {
              endArr.push(item);
            } else {
              firstArr.push(item);
            }
          }
        });
        const resArr = [...firstArr, oldItem, ...endArr];
        const clientsId = this.$store.state.choicesSchool.id;
        const packetId = this.$route.query.packetId;
        const result_list = [];
        resArr.forEach((item) => {
          result_list.push({
            result_id: item.result_id,
            detail_category_id: item.detail_category_id,
          });
        });
        this.$emit('openLoading');
        updatePacketHours(clientsId, packetId, result_list).then((res) => {
          if (res.status_code === 200) {
            this.$emit('refresh');
          } else {
            this.$message.error(res.message);
            this.$emit('closeLoading');
          }
        }).catch(() => {
          this.$emit('closeLoading');
        });
      }
    },
    // 拖动排序
    // handlerDraggable({ newIndex, oldIndex }) {
    //   if (oldIndex < this.list.length) {
    //     const list = [].concat(this.list);
    //     const allData = JSON.parse(sessionStorage.getItem('classHours'));
    //     const oldItem = list[oldIndex];
    //     const newItem = list[newIndex];
    //     let fromIndex,
    //       toIndex;
    //     allData.forEach((item, index) => {
    //       if (item.result_id === oldItem.result_id) {
    //         fromIndex = index;
    //       }
    //       if (item.result_id === newItem.result_id) {
    //         toIndex = index;
    //       }
    //     });
    //     allData[toIndex] = allData.splice(fromIndex, 1, allData[toIndex])[0];
    //     const clientsId = this.$store.state.choicesSchool.id;
    //     const packetId = this.$route.query.packetId;
    //     const result_list = [];
    //     allData.forEach((item) => {
    //       result_list.push({
    //         result_id: item.result_id,
    //         detail_category_id: item.detail_category_id,
    //       });
    //     });
    //     this.$emit('openLoading');
    //     updatePacketHours(clientsId, packetId, result_list).then((res) => {
    //       if (res.status_code === 200) {
    //         this.$emit('refresh');
    //       } else {
    //         this.$message.error(res.message);
    //         this.$emit('closeLoading');
    //       }
    //     }).catch(() => {
    //       this.$emit('closeLoading');
    //     });
    //   }
    // },
    closeCheck() {
      this.isClose = !this.isClose;
    },
    handlerChange(val) {
      this.$emit('change', val);
    },
    // 编辑（删除当前项--结尾添加新项）
    handlerEdit(row) {
      this.$router.push(`/putOn/courseList?packetId=${this.$route.query.packetId}&curId=${row.result_id}`);
    },
    // 移动
    handlerMove(row) {
      this.$emit('move', row);
    },
    // 删除
    handlerRemove(row) {
      const initArr = [];
      const classHours = JSON.parse(sessionStorage.getItem('classHours'));
      classHours.forEach((item) => {
        initArr.push({
          result_id: item.result_id,
          detail_category_id: item.detail_category_id,
        });
      });
      initArr.forEach((item, index) => {
        if (item.result_id === row.result_id) {
          initArr.splice(index, 1);
        }
      });
      const clientsId = this.$store.state.choicesSchool.id;
      const packetId = this.$route.query.packetId;
      this.$confirm('该操作将<strong style="color:red">删除</strong>课时，是否继续?', '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            updatePacketHours(clientsId, packetId, initArr)
              .then((res) => {
                done();
                if (res.status_code === 200) {
                  this.$message.success('删除课时成功！');
                } else {
                  this.$message.error(res.message);
                }
              }).finally(() => {
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      })
        .then(() => {
          this.$emit('refresh');
        }).catch(() => {

        });
    },
    gotoAdd() {
      this.$router.push(`/putOn/courseList?packetId=${this.$route.query.packetId}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 15px;
  .draggable-wrap{
    width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  }
  .add-class{
  width: 248px;
  height: 136px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F5F7FA;
  border-radius: 2px;
  border: 1px solid #DCDFE6;
  margin: 10px;
  cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/editClassHours/components/classHours/index.vue